import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { StatusChip } from '../pages/customer/OrdersPageModern';

// Modern dashboard: active order (out-for-delivery first, else newest) with a View order shortcut (no map; ETA lives on the order page).
export function ModernActiveOrderCard({ orders }) {
  const navigate = useNavigate();
  if (!orders.length) return null;
  const order = [...orders].sort((a, b) => ((b.status === 'out_for_delivery') - (a.status === 'out_for_delivery'))
    || String(b.created_at || '').localeCompare(String(a.created_at || '')))[0];
  const items = (order.items || []).reduce((n, it) => n + (Number(it.quantity) || 1), 0);
  const onTheWay = order.status === 'out_for_delivery';
  return (
    <div className="am-card" style={{ padding: 16, marginBottom: 24, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }} data-testid="modern-active-order-card">
      <div style={{ flex: '1 1 200px', minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <StatusChip status={order.status} />
          <span className="am-label" data-testid="modern-active-order-id">Order #{order.id.slice(0, 8).toUpperCase()}</span>
        </div>
        <p style={{ margin: '6px 0 0', fontSize: 13, color: 'var(--am-ink-2)' }}>
          {items} item{items === 1 ? '' : 's'}{onTheWay ? ' · see your ETA on the order page' : ''}
          {orders.length > 1 && (
            <>
              {' · '}
              <button type="button" onClick={() => navigate('/customer/orders')} style={{ border: 0, background: 'none', padding: 0, color: 'var(--am-emerald-700)', fontWeight: 600, cursor: 'pointer' }} data-testid="modern-active-orders-all">
                {orders.length} active orders
              </button>
            </>
          )}
        </p>
      </div>
      <button type="button" onClick={() => navigate(`/customer/orders/${order.id}`)} data-testid="modern-active-order-view"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 4, border: 0, cursor: 'pointer', background: 'var(--am-emerald-600)', color: '#fff', fontWeight: 600, fontSize: 14, padding: '10px 16px', borderRadius: 'var(--am-radius-pill)' }}>
        {onTheWay ? 'See ETA' : 'View order'} <ChevronRight size={14} />
      </button>
    </div>
  );
}
